import { createFileRoute } from '@tanstack/react-router';
import { UsersPanel } from '../../../features/settings/components/UsersPanel';

/** Users & roles (BUILD_SPEC.md §5.1, §6) — list tenant members, add
 * membership by email + role, change role, remove. ADMIN only. Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/users')({
  component: UsersPanel,
});
